const isWriterFromPK = (user = {}) => {
  const { address = {} } = user;
  const { country = '' } = address;

  return country === 'Pakistan';
};

export default isWriterFromPK;
